window.slate = window.slate || {};
window.theme = window.theme || {};

if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function ($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function () {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function () {
        $('a[href*=#]').on('click', function (evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

    wrapTable: function () {
        $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
    },

    iframeReset: function () {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

        $iframeVideo.each(function () {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="rte__video-wrapper"></div>');
        });

        $iframeReset.each(function () {
            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function (index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function (variant) {
                var satisfied = true;

                selectedValues.forEach(function (option) {
                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            if (!variant) return false;

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param  {variant} variant - Currently selected variant
         * @return {k}         [description]
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param  {variant} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        buyNowWrap: '.buy-now-wrap',
        btnOutOfStock: '.btn--out-of-stock',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productVideo: '[data-product-video]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productSku: '[data-product-sku]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]',
        backgroundZoomImage: '[data-product-background-image]'
    };

    var afteraySvg = document.querySelector('.icon-afterpay-logo');
    var zippaySvg = document.querySelector('.icon-zippay-logo');
    if (afteraySvg) {
        $(afteraySvg).addClass("icon--full-color");
    }
    if (zippaySvg) {
        $(zippaySvg).addClass("icon--full-color");
    }

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            // this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }

        // Zoom on hover of image
        $('.product__image').on('mousemove' + this.namespace, this.zoomProductImage.bind(this));

        // Listen to the form submit event
        var productThis = this;

        var form = document.querySelector('.product__form');
        form.addEventListener('submit', this.addProductHandler.bind(this));

        this.$productImages = $(selectors.productFeaturedImage);
        this.$thumbs = $(selectors.productThumbs);

        if (this.$productImages.length) {
            $('.product__image-slider').slick({
                slidesToShow: 1,
                arrows: true,
                dots: false,
                accessibility: false
            });

            $('.product__image-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var selectedVariant = slick.$slides.get(nextSlide).dataset.variantOption;
                var selectVariant = $('#SingleOptionSelector-1');

                if (selectVariant.length > 0 && selectedVariant !== '') {
                    selectVariant.val(selectedVariant)
                    productThis.variants._onSelectChange();
                }

                // var selectVariant = document.querySelectorAll('#SingleOptionSelector-1 option');
                // if(selectVariant) {
                //   $.each(selectVariant, function(i, option) {
                //     if(selectedVariant !== '') {
                //       option.removeAttribute('selected');
                //     }
                //     if(option.getAttribute('data-variant-title') === selectedVariant) {
                //       option.setAttribute('selected', 'selected');
                //       productThis.variants._onSelectChange();
                //     }
                //   });
                // }

            });
        }

        if (this.$thumbs.length) {
            $('.product__thumbnails').slick({
                slidesToShow: 4,
                arrows: true,
                dots: false,
                accessibility: false
            });

            $('.product__thumbnail').on('click', function () {
                $('.product__image-slider').slick('slickGoTo', $(this).data('slick-index'));
            });

            $('#SingleOptionSelector-1').change(function () {
                changeSlide(this)
            });

            function changeSlide(el) {
                var variantOption = $(el).val();
                var slickIndex = $('.product__image-slider').find('[data-variant-option="' + variantOption + '"]').first().data('slick-index');
                if (slickIndex !== undefined) {
                    $('.product__image-slider').slick('slickGoTo', slickIndex);
                }
            }

            changeSlide('#SingleOptionSelector-1')
        }
        /**
         * On click of thumbails, check to see if the thumbnail is a video or not
         * and replace featured image/video with thumbnail.
         */
        $('.product__thumbnails').on('click' + this.namespace, this.$thumbs, function (e) {
            e.preventDefault();

            // if ($(this).is('[data-product-video]')) {
            //   $('[data-product-featured-image]').replaceWith('<video src="' +
            //                                                  e.currentTarget.href + '" controls autoplay data-product-featured-image></video>');
            //   $('[data-product-background-image]').css('background-image', 'none');
            // } else {
            //   $('[data-product-featured-image]').replaceWith('<img src="' +
            //                                                  e.currentTarget.href + '"data-product-featured-image />');
            //   $('[data-product-background-image]').css('background-image', 'url(' + e.currentTarget.href + ')');
            // }

            var productSingleThumbnail = $(e.target).closest('[data-product-single-thumbnail]');

            if (productSingleThumbnail.length > 0) {
                var selectedVariant = productSingleThumbnail.data('variantId');
                var selectVariant = $('#SingleOptionSelector-1');

                if (selectVariant.length > 0 && selectedVariant !== '') {
                    selectVariant.val(selectedVariant)
                    productThis.variants._onSelectChange();
                }

                // var selectVariantOption = document.querySelectorAll('#SingleOptionSelector-1 option');
                // if(selectVariantOption) {
                //   $.each(selectVariantOption, function(i, option) {
                //     if(selectedVariant !== '') {
                //       option.removeAttribute('selected');
                //     }
                //     if(option.getAttribute('data-variant-title') === selectedVariant) {
                //       option.setAttribute('selected', 'selected');
                //       productThis.variants._onSelectChange();
                //     }
                //   });
                // }
            }
        });
    }


    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true).hide();
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.buyNowWrap, this.$container).hide();
                $(selectors.btnOutOfStock, this.$container).show();
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false).show();
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                $(selectors.buyNowWrap, this.$container).show();
                $(selectors.btnOutOfStock, this.$container).hide();
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true).hide();
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                $(selectors.buyNowWrap, this.$container).hide();
                $(selectors.btnOutOfStock, this.$container).show();
            }

            // Also update the sku
            var skuString = variant.sku === '' ? '' : 'SKU - ' + variant.sku;
            $(selectors.productSku).html(skuString);
        },


        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },


        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            var variant = evt.variant;

            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

            $('[data-product-featured-image]').replaceWith('<img src="' +
                sizedImgUrl + '"data-product-featured-image />');
            $('[data-product-background-image]').css('background-image', 'url(' + sizedImgUrl + ')');
        },


        /**
         * Zoom the image on hover
         */
        zoomProductImage: function (e) {

            var container = e.currentTarget;
            var offsetX = e.offsetX || e.touches[0].pageX;
            var offsetY = e.offsetY || e.touches[0].pageY;
            var x = (offsetX / container.offsetWidth) * 100;
            var y = (offsetY / container.offsetHeight) * 100;

            container.style.backgroundPosition = x + '% ' + y + '%';
        },


        /**
         * Handler to add product to cart via ajax request
         */
        addProductHandler: function (e) {

            e.preventDefault();

            var sizeProp = e.target.querySelector('#Size');
            var spanText = e.target.querySelector('[data-add-to-cart-text]');

            if (sizeProp === null || sizeProp.value !== '') {

                var form = e.target;
                var button = form.add;

                if (spanText.innerHTML === 'Choose a ring size') {
                    spanText.innerHTML = 'Add to cart';
                }

                var formData = {
                    id: form.id.value,
                    quantity: form.quantity.value
                };

                if (sizeProp) {
                    formData.properties = {
                        'Size': sizeProp.value
                    };
                }

                // Send the updated cart data

                var size = {};

                if ($('.product__form #Size').length) {
                    size = {
                        'Size': $('.product__form #Size').val()
                    }
                }

                CartJS.addItem(formData.id, formData.quantity,
                    size, {
                        "success": function(data, textStatus, jqXHR) {

                            theme.cart.fetchData(function () {

                                theme.cart.updateBadges();
                                theme.cart.updateSubtotal();
                                theme.cart.updateCartItems(function () {
                                    button.classList.remove('btn--loading');
                                    theme.cart_slider.init();
                                    theme.cart.openCartDrawer();
                                });
                            });
                        },

                        // Define an error callback to display an error message.
                        "error": function(jqXHR, textStatus, errorThrown) {

                        }
                    });

                // $.ajax({
                //     method: 'POST',
                //     url: form.action,
                //     data: formData,

                //     success: function () {
                //         theme.cart.fetchData(function () {
                //             theme.cart.updateBadges();
                //             theme.cart.updateSubtotal();
                //             theme.cart.updateCartItems(function () {
                //                 button.classList.remove('btn--loading');
                //                 theme.cart_slider.init();
                //                 theme.cart.openCartDrawer();
                //             });
                //         });
                //     }
                // });
            } else {
                spanText.innerHTML = 'Choose a ring size';
                this.checkSize();
            }
        },

        checkSize: function () {
            var sizeProp = document.querySelector('#Size');

            sizeProp.addEventListener('change', function () {
                var spanText = document.querySelector('[data-add-to-cart-text]');
                spanText.innerHTML = 'Add to cart';
            });
        },


        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

theme.productBtnBackTo = {
    init: function () {
        var productCtaBack = $('.product__cta-back');
        var currentUrl = window.location.href;

        if (productCtaBack.length == 0 || currentUrl.indexOf('/products/') == -1) {
            return false;
        }

        var referrer = document.referrer || '/';
        var ctaText = window.theme.strings.back;

        if (referrer.indexOf('collection') != -1) {
            ctaText = window.theme.strings.backToCategory;
        }

        if (referrer.indexOf('search') != -1) {
            ctaText = window.theme.strings.backToSearch;
        }

        productCtaBack.attr('href', referrer).find('span').text(ctaText);
    }
}

theme.productAccordion = {
    init: function () {
        $(".product-accordion__title").click(function () {
            if ($(this).siblings(".product-accordion__content").hasClass("show-accordion")) {
                $(this).siblings(".product-accordion__content").removeClass("show-accordion");
                $(this).find(".product-accordion__indicator").text("+");
            } else {
                $(".product-tabs__content").addClass("show-accordion");
                $(this).siblings(".product-accordion__content").addClass("show-accordion");
                $(this).find(".product-accordion__indicator").text("-");
            }
        });

        $(document).on('variantChange', function (e) {

            if (!e.variant) return false;

            var domVariant = e.variant,
                caratInfo = $('li:contains("Total Carat Equivalent:")');

            caratInfo.html("Total Carat Equivalent: " + domVariant.option2);
        });
    }

};

theme.HeroSlider = (function () {

    /**
     * Constructor
     */
    function HeroSlider(container) {

        this.settings = container.dataset.sectionSettings || "{}";
        this.$slider = $(container).find('.slider');

        // Parse the settings string passed through from liquid
        var userSettings = JSON.parse(this.settings);

        // Create some defaults
        var defaultSettings = {
            infinite: true,
            autoplaySpeed: userSettings.slide_speed,
            speed: (userSettings.slide_speed / 2),
            responsive: [
                {
                    breakpoint: window.theme.settings.grid_medium || 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // Merge the objects - userSettings will have precedence
        var sliderSettings = $.extend(defaultSettings, userSettings);
        // Init slick carousel
        this.$slider.slick(sliderSettings);
    }

    /**
     * Event handler that updates the fade setting based on slidesToShow
     */
    function slideHandler(e) {

        if (e.target.name.indexOf('slidesToShow')) {
            var fade = window.top.document.querySelector('[id="fade"]');

            if (e.target.value > 1) {
                fade.checked = false;
                fade.disabled = true;
            }
            else {
                fade.checked = true;
                fade.disabled = false;
            }
        }
    }

    /**
     * Shopify section methods
     */
    HeroSlider.prototype = $.extend({}, HeroSlider.prototype, {

        onSelect: function (e) {
            window.top.addEventListener('input', slideHandler);
            window.top.addEventListener('change', slideHandler);
        },

        onDeselect: function (e) {
            window.top.removeEventListener('input', slideHandler);
            window.top.removeEventListener('change', slideHandler);
        },

        onBlockSelect: function (e) {
            // Go to the currently selected block in slick carousel and pause
            var index = parseInt(e.target.dataset.slickIndex, 10);
            this.$slider.slick('slickGoTo', index).slick('slickPause');
        },

        onBlockDeselect: function (e) {
            // Resume carousel
            this.$slider.slick('slickPlay');
        }

    });

    return HeroSlider;
})();

theme.Testimonials = (function () {

    /**
     * Constructor
     */
    function Testimonials(container) {

        this.settings = container.dataset.sectionSettings || "{}";
        this.$slider = $(container).find('.slider');

        // Parse the settings string passed through from liquid
        var userSettings = JSON.parse(this.settings);

        // Create some defaults
        var defaultSettings = {
            infinite: true,
            autoplaySpeed: userSettings.slide_speed,
            speed: (userSettings.slide_speed / 2),
            responsive: [
                {
                    breakpoint: window.theme.settings.grid_medium || 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // Merge the objects - userSettings will have precedence
        var sliderSettings = $.extend(defaultSettings, userSettings);
        // Init slick carousel
        this.$slider.slick(sliderSettings);
    }

    /**
     * Event handler that updates the fade setting based on slidesToShow
     */
    function slideHandler(e) {

        if (e.target.name.indexOf('slidesToShow')) {
            var fade = window.top.document.querySelector('[id="fade"]');

            if (e.target.value > 1) {
                fade.checked = false;
                fade.disabled = true;
            }
            else {
                fade.checked = true;
                fade.disabled = false;
            }
        }
    }

    /**
     * Shopify section methods
     */
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {

        onSelect: function (e) {
            window.top.addEventListener('input', slideHandler);
            window.top.addEventListener('change', slideHandler);
        },

        onDeselect: function (e) {
            window.top.removeEventListener('input', slideHandler);
            window.top.removeEventListener('change', slideHandler);
        },

        onBlockSelect: function (e) {
            // Go to the currently selected block in slick carousel and pause
            var index = parseInt(e.target.dataset.slickIndex, 10);
            this.$slider.slick('slickGoTo', index).slick('slickPause');
        },

        onBlockDeselect: function (e) {
            // Resume carousel
            this.$slider.slick('slickPlay');
        }

    });

    return Testimonials;
})();

theme.featuredCollectionSlider = {
    // Function to kick in Slick slider for mobile
    //  on featured collection product cards.

    // Note: .not('slick-initialized') is to stop
    //  double firing on initialize when resizing.

    init: function () {
        // Global Variables
        const slickContainer = $('[data-section-type="featured-collection"] .grid.grid--uniform.slick-slider');
        const myWindow = $(window);
        const sliderSettings = {
            centerMode: true,
            arrows: false,
            dots: false,
            centerPadding: "20%",
            infinite: false
        };

        // On load, kick in slider
        if (myWindow.width() <= 768) {
            $(slickContainer)
                .not(".slick-initialized")
                .slick(sliderSettings);
        }

        // If on resize, kick in slider or kill
        myWindow.on("resize", function () {
            if (myWindow.width() <= 768) {
                $(slickContainer)
                    .not(".slick-initialized")
                    .slick(sliderSettings);
            } else {
                $(slickContainer).slick("unslick");
            }
        });
    }
};

theme.featuredArticleSlider = {
    // Function to kick in Slick slider for mobile
    //  on featured article cards.

    // Note: .not('slick-initialized') is to stop
    //  double firing on initialize when resizing.

    init: function () {
        // Global Variables
        const slickContainer = $('[data-section-type="featured-articles"] .grid.grid--uniform.slick-slider');
        const myWindow = $(window);
        const sliderSettings = {
            centerMode: true,
            arrows: false,
            dots: false,
            centerPadding: "20%",
            infinite: false
        };

        // On load, kick in slider
        if (myWindow.width() <= 768) {
            $(slickContainer)
                .not(".slick-initialized")
                .slick(sliderSettings);
        }

        // If on resize, kick in slider or kill
        myWindow.on("resize", function () {
            if (myWindow.width() <= 768) {
                $(slickContainer)
                    .not(".slick-initialized")
                    .slick(sliderSettings);
            } else {
                $(slickContainer).slick("unslick");
            }
        });
    }
};

theme.footerAccordion = {

    init: function () {

        $('.footer__inner .nav--level-one .nav__item h5').click(function () {
            if ($(window).width() < 768) {
                $(this).next('.nav--level-two').slideToggle();

                if ($(this).find('.icon-plus').is(':visible')) {
                    $(this).find('.icon-plus').hide();
                    $(this).find('.icon-minus').show();
                } else {
                    $(this).find('.icon-plus').show();
                    $(this).find('.icon-minus').hide();
                }
            } else {
                $('.footer__inner .nav--level-one .nav__item h5').unbind('click');
            }
        });
    }
};


/*================ Modules ================*/
theme.header = {
    /*
       * Public vars
       */
    isFixed: false,


    /**
     * The initialising code
     */
    init: function () {

        var self = this;

        // Scroll listener
        window.registerScrollHandler.push(this.scrollHandler.bind(this));
        this.scrollHandler();

        // Menu toggle
        var btnMenus = document.querySelectorAll('.header__btn--menu');
        btnMenus.forEach(el => el.addEventListener('click', self.btnMenuClickHandler.bind(self))
    )
        ;

        // Menu item toggle
        var navLinks = document.querySelectorAll('.nav__item--has-child > a');
        navLinks.forEach(el => el.addEventListener('click', self.navLinkClickHandler.bind(self))
    )
        ;
    },


    /**
     * Window scroll handler, adds class to body if scrolled past banner
     */
    scrollHandler: function () {

        var waypoint = 0;

        // Check if we've scrolled past the banner
        if (window.pageYOffset > waypoint) {
            if (!this.isFixed) {
                document.body.classList.add('header-fixed');
                this.isFixed = true;
            }
        }
        else {
            if (this.isFixed) {
                document.body.classList.remove('header-fixed');
                this.isFixed = false;
            }
        }
    },


    /**
     * .header__btn--menu click handler
     */
    btnMenuClickHandler: function () {
        document.body.classList.toggle('menu-expanded');
    },


    /**
     * .nav__item--has-child > a click handler
     */
    navLinkClickHandler: function (e) {

        var w = window,
            d = document,
            docEl = d.documentElement,
            bodyEl = d.getElementsByTagName('body')[0],
            x = w.innerWidth || docEl.clientWidth || bodyEl.clientWidth,
            y = w.innerHeight || docEl.clientHeight || bodyEl.clientHeight;

        var windowWidth = x;

        function resize() {
            windowWidth = window.innerHeight;
        }

        window.addEventListener("resize", function () {
            resize();
        });

        if (windowWidth < 990) {

            e.preventDefault();
            e.target.parentElement.classList.toggle('nav__item--expanded');

        }
    }
};

theme.searchModal = function () {

    var banner = document.querySelector('.banner');
    var header = document.querySelector('.header');
    var container = document.querySelector('.search--modal');

    if (!container) {
        console.debug('no searchModal container found');
        return;
    }

    var inner = container.querySelector('.search__inner');
    var $container = $(container);

    updateOffset();

    var form = container.querySelector('form');
    var input = container.querySelector('input[name="q"]');
    // var closeButton = form.querySelector('.search__close');
    // var results = container.querySelector('.search__results .grid');
    //
    // var cachedTerm = '';
    // var currentAjaxRequest = null;

    var searchButton = document.querySelector('.header__btn--search');

    var isShowing = false;
    searchButton.addEventListener('click', toggleModal);

    // input.addEventListener('input', inputHandler);
    form.addEventListener('submit', submitHandler);


    /**
     * Adds margin to search container so it sits under the header
     */
    function updateOffset() {

        var bannerHeight = banner ? banner.clientHeight : 0;
        var headerHeight = header.clientHeight || 0;
        var offset = bannerHeight + headerHeight;

        inner.style.marginTop = offset + 'px';
    }


    /**
     * Shows the search modal
     */
    function toggleModal() {
        if (isShowing) {
            hide();
        }
        else {
            show();
        }
    }


    /**
     * Shows the search modal
     */
    function show() {

        document.body.classList.add('search-modal-showing');

        // input.addEventListener('input', inputHandler);
        // closeButton.addEventListener('click', hide);
        // document.addEventListener('keydown', keydownHandler);
        input.addEventListener('focus', termFocusHandler);

        slate.a11y.trapFocus({
            $container: $container,
            namespace: 'container',
            $elementToFocus: $(input)
        });

        isShowing = true;
    }


    /**
     * Hides the search modal
     */
    function hide() {

        document.body.classList.remove('search-modal-showing');

        // input.removeEventListener('input', inputHandler);
        // closeButton.removeEventListener('click', hide);
        // document.removeEventListener('keydown', keydownHandler);
        input.removeEventListener('focus', termFocusHandler);

        slate.a11y.removeTrapFocus({
            $container: $container,
            namespace: 'container'
        });

        isShowing = false;
    }


    // /**
    //  * Handles the search input
    //  */
    // function inputHandler() {
    //
    // 	var term = input.value;
    //
    // 	if (term.length > 2 && term !== cachedTerm) {
    // 		querySearchTerm(term);
    // 	}
    //
    // 	cachedTerm = term;
    // }
    //
    //
    //
    // /**
    //  * Handles keydown
    //  */
    // function keydownHandler(e) {
    // 	switch (e.keyCode) {
    // 		//esc
    // 		case 27:
    // 			hide();
    // 			break;
    // 	}
    // }


    /**
     * Handles focus on term input
     */
    function termFocusHandler(e) {
        // Select all the text in the search box
        var input = e.target;
        input.setSelectionRange(0, input.value.length);
    }


    // /**
    //  * Ajax request for search term and prints out the results
    //  */
    // function querySearchTerm(term) {
    // 	// Encapsulate term in * wildcard to get partial matches
    // 	// Hit our json template for search term
    // 	var searchURL = '/search?type=product&q=*'+ term +'*';
    // 	// Stop any current calls
    // 	if (currentAjaxRequest != null) currentAjaxRequest.abort();
    //
    // 	currentAjaxRequest = $.getJSON(searchURL +'&view=json', function(data) {
    // 		// Reset results.
    // 		results.innerHTML = '';
    //
    // 		if (data.results_count == 0) {
    // 			results.innerHTML = "<div class='grid'><div class='grid__item text-center'><p>No results found.</p></div></div>";
    // 		}
    // 		else {
    // 			for (var i = 0, count = data.results.length; i < count; i++) {
    // 				results.innerHTML += data.results[i].markup;
    // 			}
    // 			// If there are more than 10, let's link to the search results page.
    // 			if (data.results_count > 10) {
    // 				results.innerHTML += '<p><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></p>';
    // 			}
    // 		}
    // 	});
    // }


    /**
     * Handles the search form submission
     */
    function submitHandler(e) {
        // Wrap search term in wildcards
        e.preventDefault();

        var term = this.q.value;
        var searchURL = '/search?type=product&q=*' + term + '*';

        window.location = searchURL;
    }
};

theme.cart = {
    /*
     * Public vars
     */
    isShowing: false,
    data: {},
    currentAjaxRequest: null,
    currentTimeout: null,


    /**
     * The initialising code
     */
    init: function () {
        // Reference to this
        var self = this;

        // Cache some DOM elements
        this.cartCount = document.querySelector('.cart-count');
        this.cart = document.querySelector('.cart--drawer');
        this.header = this.cart.querySelector('.cart__header');
        this.btnClose = this.cart.querySelector('.cart__close');
        this.trigger = null;
        this.count = this.cart.querySelector('.cart__count');
        this.content = this.cart.querySelector('.cart__content');
        this.footer = this.cart.querySelector('.cart__footer');
        this.subtotal = this.cart.querySelector('.cart__subtotal');

        // Build a loader element for later use
        this.loader = document.createElement('div');
        this.loader.className = 'loader';

        // Check if we're on a cart page
        var isCartPage = document.body.classList.contains('template-cart');

        if (isCartPage) {
            // this.addItemListeners();
            theme.change_size.init();
        }
        else {
            // Initialise ajax cart
            theme.cart.updateCartItems(function () {
                theme.cart_slider.init();
                theme.change_size.init();
            });

            // Add listeners to buttons
            var buttonOpen = document.querySelector('.header__btn--cart');
            if (buttonOpen) {
                buttonOpen.addEventListener('click', this.toggleCartDrawer.bind(this));
            }

            this.btnClose.addEventListener('click', function () {
                self.closeCartDrawer();
            });

            var fade = document.querySelector('.fade');
            fade.addEventListener('click', this.closeCartDrawer.bind(this));
        }

        this.fetchData(function () {
        });
    },


    /**
     * Updates the data property with data from cart.js
     */
    fetchData: function (callback) {
        var self = this;
        Shopify.getCart( function (data) {
            self.data = data;


            if (callback) callback();
        });
    },


    /**
     * Send data to /cart/change.js
     */
    changeData: function (data, callback) {
        var self = this;

        $.ajax({
            type: 'post',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            complete: function (jqxhr, status) {
                self.fetchData(function () {
                    self.updateBadges();
                    self.updateSubtotal();
                });
                if (callback) callback(jqxhr, status);
            }
        });
    },


    /**
     * Updates the header's cart badge number by the amount passed
     */
    updateBadges: function () {

        if (this.data.item_count === 0) {
            $(theme.cart.cartCount).hide();
        } else {
            $(theme.cart.cartCount).show();
        }
        theme.cart.cartCount.innerHTML = theme.cart.count.innerHTML = this.data.item_count;
    },


    /**
     * Get's cart html from src/templates/cart.drawer.liquid
     */
    updateCartItems: function (callback) {
        var self = this;

        $.get('/cart/?view=drawer', function (data) {
            self.content.innerHTML = data;
            self.addItemListeners();

            if (callback) callback();
            $('body').trigger('ajaxCart.afterCartLoad');

            // Slide toggle slider section
            $('#CartSpecialInstructions').css('display', 'none');
            $('#cart-notes').click(function () {
                $('#CartSpecialInstructions').slideToggle();
            });
        });
    },


    /**
     * Updates the subtotal
     */
    updateSubtotal: function () {
        this.subtotal.innerHTML = slate.Currency.formatMoney(this.data.total_price, theme.moneyFormat);
        $('body').trigger('ajaxCart.afterCartLoad');
        var splitPrice = (this.data.total_price / 4);
        $('#total-split').html(slate.Currency.formatMoney(splitPrice, theme.moneyFormat));
    },


    /**
     * Call's appropriate method depending on cart state
     */
    toggleCartDrawer: function (e) {
        e.preventDefault();

        if (this.isShowing) {
            this.closeCartDrawer();
        }
        else {
            this.openCartDrawer();
        }
    },


    /**
     * Add class to body so we can animate the cart drawer to the open position
     */
    openCartDrawer: function () {

        document.body.classList.add('cart-showing');
        this.isShowing = true;

        // Capture the element that opened the cart
        this.trigger = document.activeElement;
        this.btnClose.focus();
    },


    /**
     * Removes above body class so we can animate the cart drawer to the closed position
     */
    closeCartDrawer: function () {
        document.body.classList.remove('cart-showing');
        this.isShowing = false;

        // Throw the focus back to the element that opened the cart
        if (this.trigger) {
            this.trigger.focus();
            this.trigger = null;
        }
        // Refresh the cart incase someone changes a quantity without updating
        // this.updateCartItems();
    },


    /**
     * Add event listeners to cart items (eg. buttons, inputs)
     */
    addItemListeners: function () {
        var self = this;
        var cartItems = document.querySelectorAll('.cart-item');

        cartItems.forEach(function (el) {
            el.querySelector('.quantity__control--minus').addEventListener('click', self.minusClickHandler.bind(self));
            el.querySelector('.quantity__control--plus').addEventListener('click', self.plusClickHandler.bind(self));
        });
    },


    /**
     * Handles a user quantity update event - could be made DRYer with below method
     */
    minusClickHandler: function (e) {

        e.preventDefault();

        // Clear the timeout if it is set
        if (this.currentTimeout) clearTimeout(this.currentTimeout);

        var self = this;

        var target = e.currentTarget;
        var cartItem = target.parents('.cart-item');
        var input = cartItem.querySelector('.quantity__amount');

        // update the line item quantity
        var line = Number(target.dataset.line);
        var quantity = this.data.items[line].quantity - 1;
        input.value = quantity;
        this.data.items[line].quantity = quantity;

        // update the badge counts
        this.data.item_count -= 1;
        this.updateBadges();

        // Update subtotal
        this.data.total_price -= this.data.items[line].price;
        this.updateSubtotal();

        if (quantity < 1) {
            cartItem.classList.add('removed');
        }

        // debounce the ajax call
        this.currentTimeout = setTimeout(function () {

            self.changeData({
                quantity: quantity,
                line: (line + 1)
            });

        }, 500);

    },


    /**
     * Handles a user quantity update event
     */
    plusClickHandler: function (e) {

        e.preventDefault();

        // Clear the timeout if it is set
        if (this.currentTimeout) clearTimeout(this.currentTimeout);

        var self = this;

        var target = e.currentTarget;
        // Exit if disabled
        if (target.classList.contains('quantity__control--disabled')) return;

        // TODO let user know if item is last of stock

        var cartItem = target.parents('.cart-item');
        var input = cartItem.querySelector('.quantity__amount');

        // update the line item quantity
        var line = Number(target.dataset.line);
        var quantity = this.data.items[line].quantity + 1;

        input.value = quantity;
        this.data.items[line].quantity = quantity;

        // update the badge counts
        this.data.item_count += 1;
        this.updateBadges();

        // Update subtotal
        this.data.total_price += this.data.items[line].price;
        this.updateSubtotal();

        // debounce the ajax call
        this.currentTimeout = setTimeout(function () {

            self.changeData({
                quantity: quantity,
                line: (line + 1)
            });

        }, 500);
    }
};

theme.Accordion = (function () {


    /**
     * Constructor
     */
    function Accordion(container) {
        // Public vars
        this.container = container;
        this.showingId;
        // Reference to self for use in closures
        var self = this;

        // Add click listeners to each button
        var buttons = container.querySelectorAll('.panel__heading button');
        buttons.forEach(function (el) {
            el.addEventListener('click', self.toggleBody.bind(self));
        });

    }

    /**
     * Event handler - decides what to show or hide
     */
    Accordion.prototype.toggleBody = function (e) {

        var bodyId = e.target.dataset.toggle;
        var body = this.container.querySelector('#' + bodyId);

        // Is something showing?
        if (this.showingId) {
            // Is that something showing the same as what got clicked?
            if (this.showingId === bodyId) {
                this.hideBody(body);
            }
            else {
                var showingBody = this.container.querySelector('#' + this.showingId);
                this.hideBody(showingBody);
                this.showBody(body);
            }
        }
        else {
            this.showBody(body);
        }
    },

        /**
         * Event handler - shows a panel body
         */
        Accordion.prototype.showBody = function (body) {
            body.parents('.panel').classList.remove('collapsed');
            this.showingId = body.id;
        },

        /**
         * Event handler - hides a panel body
         */
        Accordion.prototype.hideBody = function (body) {
            body.parents('.panel').classList.add('collapsed');
            this.showingId = null;
        };

    return Accordion;

}());

theme.collectionFilter = {
    init: function () {

        function closeCollectionFilters() {
            $(".snize-product-filters-title").removeClass("open");
            $(".snize-product-filters-list").css("display", "none");
        }

        setTimeout(closeCollectionFilters, 1000);
    }
};

theme.ip_data = {

    init: function () {
        // Send request to ipdata to check address
        $.get("https://api.ipdata.co", function (response) {

            // Parse JSON
            JSON.stringify(response, null, 4);

            // Build and check country info
            var ausCode = "AU",
                usCode = "US",
                countryCode = response.country_code;

            if (countryCode === ausCode || usCode) {
                // console.log('You are in AUS or US :)');
            }
            // console.log(response);
        }, "jsonp");
    }
}

theme.cart_slider = {

    init: function () {

        $('.cart__slick--wrapper').each(function () {
            var $this = $(this),
                cartSlider = $this.find('.cart__slick'),
                prevArrow = $this.find('.prev'),
                nextArrow = $this.find('.next');

            // Initialise Slick
            if (!cartSlider.hasClass('slick-initialized')) {
                cartSlider.slick({
                    slidesToShow: 3,
                    dots: false,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });

                // Bind arrows to slider
                $(prevArrow).click(function () {
                    $(cartSlider).slick('slickPrev');
                });
                $(nextArrow).click(function () {
                    $(cartSlider).slick('slickNext');
                });
            }
        });

        $('.cart__heading').click(function () {
            var $selectSvg = $(this).children('h4').children('svg'),
                $selectWrapper = $(this).parent('.cart__upsell').children('.cart__slick--wrapper');

            $selectWrapper.slideToggle();

            if ($selectSvg.hasClass('rotate')) {
                $selectSvg.removeClass('rotate');
            } else {
                $selectSvg.addClass('rotate');
            }
        });
    }
};

theme.scroller = {
    /*
    // On click of arrow, scrolls to top
    */
    scrollFire: function () {

        const scrollButton = $('.scroll-top');
        const scrollBind = $('html, body');

        $(scrollButton).click(function () {
            $(scrollBind).animate({scrollTop: 0});
        });
    }
};

// =require modules/collection-filter.js
theme.Video = (function () {

    function Video(container) {
        var iframe = container.querySelector('iframe');
        this.player = new Vimeo.Player(iframe);

        var wrapper = container.querySelector('.section__video');
        if (wrapper) {
            wrapper.addEventListener('click', this.wrapperClickHandler.bind(this));
        }
    }

    Video.prototype = $.extend({}, Video.prototype, {

        wrapperClickHandler: function (e) {
            e.currentTarget.classList.add('section__video--played');
            this.player.play();
        }
    });

    return Video;
})();

theme.change_size = {

    init: function () {

        $('.size-change').change(function () {
            var changeValue = $(this).val();
            $.post('/cart/change.js', {
                quantity: 1,
                line: 1,
                properties: {
                    Size: changeValue
                }
            }).done(function () {
                theme.cart.updateCartItems();
            });
        });
    }
};


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
            hideElement: 'AddressProvinceContainerNew'
        });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
        $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
    var config = {
        recoverPasswordForm: '#RecoverPassword',
        hideRecoverPasswordLink: '#HideRecoverPasswordLink'
    };

    if (!$(config.recoverPasswordForm).length) {
        return;
    }

    checkUrlHash();
    resetPasswordSuccess();

    $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        $('#RecoverPasswordForm').toggleClass('hide');
        $('#CustomerLoginForm').toggleClass('hide');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState.length) {
            return;
        }

        // show success message
        $('#ResetSuccess').removeClass('hide');
    }
})();


$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('hero-slider', theme.HeroSlider);
    sections.register('testimonials', theme.HeroSlider);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    if (theme.template && theme.template.hasHeader) {
        theme.header.init();
        theme.searchModal();
    }
    if (theme.template && theme.template.hasCart) {
        theme.cart.init();
    }
    if (theme.settings.scroll_switch === true) {
        theme.scroller.scrollFire();
    }

    theme.footerAccordion.init();

    theme.featuredCollectionSlider.init();

    theme.featuredArticleSlider.init();

    theme.productBtnBackTo.init();

    theme.productAccordion.init();

    theme.collectionFilter.init();

    // Accordions
    document.querySelectorAll('.accordion').forEach(function (el) {
        new theme.Accordion(el);
    });

    theme.ip_data.init();

});
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
    }
}

//ringsize_app_popup feature
// $(document).ready(function () {
//     if (!$('.product__form').length) return false;

//     var target = document.getElementById('smartwishlist');

//     var observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {

//             var $smartwishlistBtn = $('#smartwishlist'),
//                 $smartwishlistBtnCopy = $('#smartwishlist-copy');

//             if ($('#bookmarkit').hasClass('bookmarked')) {
//                 $('#bookmarkit-copy').addClass('tooltipstered bookmarked')
//             } else {
//                 $('#bookmarkit-copy').removeClass('tooltipstered bookmarked')
//             }

//             $smartwishlistBtnCopy.on('click', function () {
//                 $('#bookmarkit').trigger('click');

//                 setTimeout(function () {
//                     if ($('#bookmarkit').hasClass('bookmarked')) {
//                         $('#bookmarkit-copy').addClass('tooltipstered bookmarked')
//                     } else {
//                         $('#bookmarkit-copy').removeClass('tooltipstered bookmarked')
//                     }
//                 }, 100);
//             })
//         });
//     });

//     var config = {childList: true, characterData: true};
//     observer.observe(target, config);
// });


//Sticky add to cart block feature
$(document).ready(function () {

    if ($('.product-form-wrapper').length && $(window).width() < 768) {
        var $form = $('.product .product__form');
        $(window).on('scroll', function () {
            var topVal = $('.product .product__form').offset().top + $('.product .product__form').outerHeight(),
                backwardTopVal = $('.payment__splitter').offset().top + $('.payment__splitter').height(),
                windodOffsetPlus = window.pageYOffset + window.innerHeight;

            if (!$form.hasClass('fixed') && windodOffsetPlus >= topVal) {
                $form.addClass('fixed');
            } else if ($form.hasClass('fixed') && (windodOffsetPlus - $form.outerHeight()) < backwardTopVal) {
                //$form.removeClass('fixed');
            }
        });
    };
});

$(document).ready(function () {
    if ($(window).width() < 768) {
        $(document).on('click', '.snize-product-filters-header', function(e) {
            e.preventDefault();
            $(this).toggleClass('open-tab');
            $(this).next().toggleClass('filter-show');
        })

        $(document).on('click', '.snize-mobile-filter-header-sort', function() {
            if ($('.snize-mobile-filter-header-filter').hasClass('filter-close')) {
                $('.snize-mobile-filter-header-filter').removeClass('filter-close selected')
                $('.snize-modal .snize-close-button').trigger('click');
            }

            if (!$('.snize-mobile-filter-header-filter').hasClass('filter-close')) {
                $('.snize-mobile-container-content').removeClass('active')
            }
        })
    }

    $('.js-login-modal a').on('click', function(e) {
        e.preventDefault();
        $('.modal-login').addClass('is-show')
    })

    $('.modal-login-close, .modal-login').on('click', function(e) {
        $('.modal-login').removeClass('is-show')
    })

    $('.modal-login__wrap').on('click', function(e) {
        e.stopPropagation();
    })
})
